import React, { SVGProps } from 'react'

export default function BabylonIcon({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="338"
      height="344"
      viewBox="0 0 338 344"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={500} height={500} fill="#FFF" />
      <path
        d="M33.3116 129.574C51.239 73.0548 104.033 32.1068 166.369 32.1068C243.463 32.1068 305.96 94.7407 305.96 172.001C305.96 243.775 252.027 302.922 182.561 310.963V266.909C213.013 261.738 238.591 242.224 252.126 215.55H213.45C201.744 228.236 184.99 236.179 166.383 236.179C130.993 236.179 102.305 207.446 102.305 172C102.305 136.556 130.993 107.825 166.383 107.825C185.543 107.825 202.741 116.247 214.485 129.599H252.697C237.041 97.6939 204.274 75.7354 166.383 75.7354C113.298 75.7354 70.2656 118.835 70.2656 172C70.2656 219.708 104.916 259.31 150.387 266.938V310.986C95.5499 304.722 50.3601 266.617 33.6795 215.574H0.29434C19.546 289.468 86.6033 344 166.369 344C261.158 344 338 266.995 338 172.001C337.999 77.0072 261.156 0 166.369 0C86.19 0 18.8525 55.0983 0 129.574H33.3116Z"
        fill="black"
        transform="scale(0.8) translate(50 50)"
      />
      <path
        d="M202 171.999C202 191.882 186.105 208 166.5 208C146.895 208 131 191.882 131 171.999C131 152.118 146.895 136 166.5 136C186.105 136 202 152.118 202 171.999Z"
        fill="black"
        transform="scale(0.8) translate(50 50)"
      />
    </svg>
  )
}
